import { useState, useCallback } from 'react';
import Swal from 'sweetalert2';

const BASE_URL = process.env.REACT_APP_API_URL;

export const useApi = () => {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (endpoint, method = 'GET', body = null, showSuccess = false) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const config = { method, headers };
      if (body) config.body = JSON.stringify(body);

      const response = await fetch(`${BASE_URL}/api${endpoint}`, config);
      
      // Evitar error si el backend responde 404 o texto plano
      const text = await response.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch(e) { data = { message: text }; }

      if (!response.ok) {
        throw new Error(data.message || data.error || "Ocurrió un error en la operación");
      }

      if (showSuccess) {
        Swal.fire({ icon: 'success', title: '¡Éxito!', text: data.message || 'Operación exitosa', confirmButtonColor: '#3b82f6' });
      }

      return { success: true, data };

    } catch (error) {
      console.error(`Error en API [${method}] ${endpoint}:`, error.message);
      // Evitamos que el Swal bloquee el bucle de errores silenciosos
      if (error.message !== "Failed to fetch") {
        Swal.fire({ icon: 'error', title: 'Oops...', text: error.message || 'Error de conexión con el servidor', confirmButtonColor: '#ef4444' });
      }
      return { success: false, data: null };

    } finally {
      setLoading(false);
    }
  }, []); // <-- El array vacío hace que la función sea estable

  return { request, loading };
};